module.exports = __webpack_public_path__ + "assets/GoldEta.eb6088bd98b42e030abe334a59c007eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldEta.png
// module id = 761
// module chunks = 0